/* ============================================================
   SHOPIFY CUSTOM REVIEWS
   Multiple Google Sheet Tabs

   Required columns:
   ProductHandle | ReviewerName | Rating | ReviewText | Date

   Supported dates:
   18-11-2025
   18/11/2025
   2025-11-18
   ============================================================ */


/* ============================================================
   GOOGLE SHEET CSV URLS

   Add each category sheet URL here.

   IMPORTANT:
   Leave placeholder URLs as they are until you have the
   real published CSV URL. The script will ignore placeholders.
   ============================================================ */

const CR_SHEETS = [

  {
    name: "Sofa",
    url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTh7fApaJKXShLZkZaLJvYJ71EADU8HsqzYf6EpCRPMyGaCMSFBJZlhcmaK9kWr60RVVbMxxG9kLYF4/pub?gid=1411416162&single=true&output=csv"
  },

  {
    name: "Sofa Bed",
    url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTh7fApaJKXShLZkZaLJvYJ71EADU8HsqzYf6EpCRPMyGaCMSFBJZlhcmaK9kWr60RVVbMxxG9kLYF4/pub?gid=1953759144&single=true&output=csv"
  },

  {
    name: "Bed Cot",
    url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTh7fApaJKXShLZkZaLJvYJ71EADU8HsqzYf6EpCRPMyGaCMSFBJZlhcmaK9kWr60RVVbMxxG9kLYF4/pub?gid=1183196623&single=true&output=csv"
  },

  {
    name: "Armchair",
    url: "PASTE_ARMCHAIR_CSV_URL_HERE"
  },

  {
    name: "Ottoman",
    url: "PASTE_OTTOMAN_CSV_URL_HERE"
  },

  {
    name: "Recliner",
    url: "PASTE_RECLINER_CSV_URL_HERE"
  }

];


/* ============================================================
   SETTINGS
   ============================================================ */

const CR_DEBUG = true;

const REVIEWS_PER_PAGE = 5;


/* ============================================================
   DEBUG
   ============================================================ */

function crLog(...args) {

  if (CR_DEBUG) {

    console.log(
      "[Custom Reviews]",
      ...args
    );
  }
}


function crError(...args) {

  console.error(
    "[Custom Reviews]",
    ...args
  );
}


/* ============================================================
   CSS
   ============================================================ */

function injectCustomReviewStyles() {

  if (
    document.getElementById(
      "cr-forced-review-styles"
    )
  ) {

    return;
  }


  const style =
    document.createElement(
      "style"
    );


  style.id =
    "cr-forced-review-styles";


  style.textContent = `

    /* =========================================
       STARS
       ========================================= */

    .cr-stars {
      display: inline-flex !important;
      align-items: center !important;
      gap: 1px !important;
      line-height: 1 !important;
      white-space: nowrap !important;
    }


    .cr-star {
      display: inline-block !important;

      font-family:
        Arial,
        Helvetica,
        sans-serif !important;

      font-style: normal !important;
      font-weight: 400 !important;

      line-height: 1 !important;

      background: none !important;
      background-image: none !important;

      text-shadow: none !important;

      opacity: 1 !important;
      visibility: visible !important;

      filter: none !important;
    }


    .cr-star--full,
    .cr-star--half {
      color: #f5a623 !important;
      -webkit-text-fill-color: #f5a623 !important;
    }


    .cr-star--empty {
      color: #d6d6d6 !important;
      -webkit-text-fill-color: #d6d6d6 !important;
    }


    /* =========================================
       REVIEW BAR
       ========================================= */

    .cr-bar-track {
      overflow: hidden;
    }


    .cr-bar-fill {
      display: block !important;
      height: 100% !important;
      min-width: 0 !important;

      background: #f5a623 !important;
      background-color: #f5a623 !important;

      opacity: 1 !important;
      visibility: visible !important;
    }


    /* =========================================
       CLICKABLE PRODUCT SUMMARY
       ========================================= */

    [data-cr-summary] {
      cursor: pointer;
    }

  `;


  document.head.appendChild(
    style
  );
}


injectCustomReviewStyles();


/* ============================================================
   ESCAPE HTML
   ============================================================ */

function escapeHTML(value) {

  const div =
    document.createElement(
      "div"
    );


  div.textContent =
    value === null ||
    value === undefined
      ? ""
      : String(value);


  return div.innerHTML;
}


/* ============================================================
   NORMALIZE PRODUCT HANDLE
   ============================================================ */

function normalizeHandle(value) {

  if (!value) {

    return "";
  }


  let handle =
    String(value)
      .trim()
      .toLowerCase();


  /*
   * Full Shopify URL support
   */
  const productMatch =
    handle.match(
      /\/products\/([^/?#]+)/
    );


  if (
    productMatch &&
    productMatch[1]
  ) {

    handle =
      productMatch[1];
  }


  /*
   * Remove query/hash
   */
  handle =
    handle.split("?")[0];

  handle =
    handle.split("#")[0];


  /*
   * Remove slashes
   */
  handle =
    handle.replace(
      /^\/+|\/+$/g,
      ""
    );


  /*
   * Spaces -> hyphen
   */
  handle =
    handle
      .replace(
        /\s+/g,
        "-"
      )
      .replace(
        /-+/g,
        "-"
      );


  return handle;
}


/* ============================================================
   CURRENT SHOPIFY PRODUCT HANDLE

   Example:
   /products/cloud-sofa

   returns:
   cloud-sofa
   ============================================================ */

function getCurrentProductHandle() {

  const match =
    window.location.pathname.match(
      /\/products\/([^/?#]+)/
    );


  if (
    !match ||
    !match[1]
  ) {

    return "";
  }


  return normalizeHandle(
    match[1]
  );
}


/* ============================================================
   GET HANDLE FROM ELEMENT

   Product page sections automatically fall back
   to current URL handle.
   ============================================================ */

function getElementHandle(
  element,
  attribute,
  allowCurrentProduct = false
) {

  const raw =
    element.getAttribute(
      attribute
    );


  const attributeHandle =
    normalizeHandle(
      raw
    );


  if (
    attributeHandle
  ) {

    return attributeHandle;
  }


  if (
    allowCurrentProduct
  ) {

    return getCurrentProductHandle();
  }


  return "";
}


/* ============================================================
   CSV PARSER

   Supports quoted commas:
   "Great sofa, very comfortable"
   ============================================================ */

function parseCSV(text) {

  const rows = [];

  let row = [];

  let field = "";

  let inQuotes = false;


  for (
    let i = 0;
    i < text.length;
    i++
  ) {

    const char =
      text[i];

    const next =
      text[i + 1];


    if (inQuotes) {

      if (
        char === '"' &&
        next === '"'
      ) {

        field += '"';

        i++;


      } else if (
        char === '"'
      ) {

        inQuotes = false;


      } else {

        field += char;
      }


    } else {

      if (
        char === '"'
      ) {

        inQuotes = true;


      } else if (
        char === ","
      ) {

        row.push(
          field
        );

        field = "";


      } else if (
        char === "\n" ||
        char === "\r"
      ) {

        if (
          field !== "" ||
          row.length
        ) {

          row.push(
            field
          );

          rows.push(
            row
          );


          row = [];

          field = "";
        }


        if (
          char === "\r" &&
          next === "\n"
        ) {

          i++;
        }


      } else {

        field += char;
      }
    }
  }


  if (
    field !== "" ||
    row.length
  ) {

    row.push(
      field
    );

    rows.push(
      row
    );
  }


  return rows;
}


/* ============================================================
   NORMALIZE GOOGLE SHEET HEADER

   Makes these work:

   ProductHandle
   Product Handle
   product_handle

   All become:
   producthandle
   ============================================================ */

function normalizeHeader(value) {

  return String(
    value || ""
  )
    .replace(
      /^\uFEFF/,
      ""
    )
    .trim()
    .toLowerCase()
    .replace(
      /[\s_-]+/g,
      ""
    );
}


/* ============================================================
   ROWS -> REVIEW OBJECTS
   ============================================================ */

function rowsToObjects(rows) {

  if (
    !rows.length
  ) {

    throw new Error(
      "Google Sheet CSV is empty."
    );
  }


  const rawHeaders =
    rows[0];


  const normalizedHeaders =
    rawHeaders.map(
      normalizeHeader
    );


  const columnMap = {

    producthandle:
      normalizedHeaders.indexOf(
        "producthandle"
      ),

    reviewername:
      normalizedHeaders.indexOf(
        "reviewername"
      ),

    rating:
      normalizedHeaders.indexOf(
        "rating"
      ),

    reviewtext:
      normalizedHeaders.indexOf(
        "reviewtext"
      ),

    date:
      normalizedHeaders.indexOf(
        "date"
      )

  };


  const missing = [];


  Object.entries(
    columnMap
  ).forEach(
    ([key, index]) => {

      if (
        index === -1
      ) {

        missing.push(
          key
        );
      }
    }
  );


  if (
    missing.length
  ) {

    throw new Error(
      `Missing columns: ${missing.join(", ")}`
    );
  }


  return rows
    .slice(1)

    .filter(
      row =>
        row.some(
          cell =>
            String(
              cell || ""
            ).trim() !== ""
        )
    )

    .map(
      row => ({

        ProductHandle:
          String(
            row[
              columnMap.producthandle
            ] ||
            ""
          ).trim(),

        ReviewerName:
          String(
            row[
              columnMap.reviewername
            ] ||
            ""
          ).trim(),

        Rating:
          String(
            row[
              columnMap.rating
            ] ||
            ""
          ).trim(),

        ReviewText:
          String(
            row[
              columnMap.reviewtext
            ] ||
            ""
          ).trim(),

        Date:
          String(
            row[
              columnMap.date
            ] ||
            ""
          ).trim()

      })
    );
}


/* ============================================================
   VALID GOOGLE SHEETS
   ============================================================ */

function getValidSheets() {

  return CR_SHEETS.filter(
    sheet => {

      if (
        !sheet ||
        !sheet.url
      ) {

        return false;
      }


      const url =
        String(
          sheet.url
        ).trim();


      if (
        url.startsWith(
          "PASTE_"
        )
      ) {

        return false;
      }


      return /^https?:\/\//i.test(
        url
      );
    }
  );
}


/* ============================================================
   LOAD ALL GOOGLE SHEETS
   ============================================================ */

let reviewsByHandle =
  null;


let reviewsPromise =
  null;


async function loadReviews() {

  /*
   * Already loaded
   */
  if (
    reviewsByHandle
  ) {

    return reviewsByHandle;
  }


  /*
   * Request already running
   */
  if (
    reviewsPromise
  ) {

    return reviewsPromise;
  }


  reviewsPromise =
    (async () => {

      const validSheets =
        getValidSheets();


      if (
        !validSheets.length
      ) {

        throw new Error(
          "No valid Google Sheet URLs configured."
        );
      }


      const grouped = {};


      let successfulSheets =
        0;


      const cacheKey =
        Date.now();


      for (
        let sheetIndex = 0;
        sheetIndex <
        validSheets.length;
        sheetIndex++
      ) {

        const sheet =
          validSheets[
            sheetIndex
          ];


        try {

          const separator =
            sheet.url.includes("?")
              ? "&"
              : "?";


          const requestUrl =
            `${sheet.url}${separator}_cr=${cacheKey}`;


          crLog(
            `Loading ${sheet.name}:`,
            requestUrl
          );


          const response =
            await fetch(
              requestUrl,
              {
                method:
                  "GET",

                cache:
                  "no-store"
              }
            );


          if (
            !response.ok
          ) {

            throw new Error(
              `HTTP ${response.status}`
            );
          }


          const text =
            await response.text();


          if (
            !text ||
            !text.trim()
          ) {

            throw new Error(
              "Google Sheet returned empty CSV."
            );
          }


          const rows =
            parseCSV(
              text
            );


          const reviews =
            rowsToObjects(
              rows
            );


          successfulSheets++;


          crLog(
            `${sheet.name}: ${reviews.length} rows loaded`
          );


          reviews.forEach(
            (
              review,
              rowIndex
            ) => {

              const handle =
                normalizeHandle(
                  review.ProductHandle
                );


              const rating =
                Number.parseFloat(
                  review.Rating
                );


              if (
                !handle
              ) {

                crLog(
                  `${sheet.name}: skipped row ${rowIndex + 2} because ProductHandle is empty`
                );

                return;
              }


              if (
                !Number.isFinite(
                  rating
                ) ||
                rating < 1 ||
                rating > 5
              ) {

                crLog(
                  `${sheet.name}: skipped invalid rating`,
                  review
                );

                return;
              }


              if (
                !grouped[
                  handle
                ]
              ) {

                grouped[
                  handle
                ] = [];
              }


              grouped[
                handle
              ].push({

                id:
                  `${sheetIndex}-${rowIndex}-${handle}`,

                source:
                  sheet.name,

                name:
                  review.ReviewerName ||
                  "Anonymous",

                rating,

                text:
                  review.ReviewText ||
                  "",

                date:
                  review.Date ||
                  ""

              });
            }
          );


        } catch (
          error
        ) {

          crError(
            `${sheet.name} sheet failed:`,
            error
          );
        }
      }


      if (
        successfulSheets === 0
      ) {

        throw new Error(
          "All review sheets failed to load."
        );
      }


      reviewsByHandle =
        grouped;


      crLog(
        "ALL REVIEW PRODUCT HANDLES:",
        Object.keys(
          grouped
        )
      );


      crLog(
        "CURRENT SHOPIFY PRODUCT HANDLE:",
        getCurrentProductHandle()
      );


      return grouped;

    })();


  try {

    return await reviewsPromise;


  } finally {

    reviewsPromise =
      null;
  }
}


/* ============================================================
   REVIEW STATISTICS
   ============================================================ */

function computeStats(
  reviews
) {

  const counts = {
    5: 0,
    4: 0,
    3: 0,
    2: 0,
    1: 0
  };


  let sum =
    0;


  reviews.forEach(
    review => {

      const rating =
        Number(
          review.rating
        );


      sum +=
        rating;


      const rounded =
        Math.max(
          1,
          Math.min(
            5,
            Math.round(
              rating
            )
          )
        );


      counts[
        rounded
      ]++;
    }
  );


  const total =
    reviews.length;


  const avg =
    total
      ? sum / total
      : 0;


  return {
    counts,
    total,
    avg
  };
}


/* ============================================================
   STAR HTML
   ============================================================ */

function starsHTML(
  rating
) {

  const numericRating =
    Number(
      rating
    ) || 0;


  let html = `
    <span
      class="cr-stars"
      aria-hidden="true"
    >
  `;


  for (
    let star = 1;
    star <= 5;
    star++
  ) {

    if (
      numericRating >=
      star - 0.25
    ) {

      html += `
        <span
          class="cr-star cr-star--full"
          style="
            color:#f5a623 !important;
            -webkit-text-fill-color:#f5a623 !important;
          "
        >★</span>
      `;


    } else if (
      numericRating >=
      star - 0.75
    ) {

      html += `
        <span
          class="cr-star cr-star--half"
          style="
            color:#f5a623 !important;
            -webkit-text-fill-color:#f5a623 !important;
          "
        >★</span>
      `;


    } else {

      html += `
        <span
          class="cr-star cr-star--empty"
          style="
            color:#d6d6d6 !important;
            -webkit-text-fill-color:#d6d6d6 !important;
          "
        >★</span>
      `;
    }
  }


  html +=
    "</span>";


  return html;
}


/* ============================================================
   PARSE REVIEW DATE

   Main format:
   DD-MM-YYYY

   Example:
   18-11-2025
   ============================================================ */

function parseReviewDate(
  dateString
) {

  if (
    !dateString
  ) {

    return null;
  }


  const value =
    String(
      dateString
    ).trim();


  let match;


  /* ============================================================
     DD-MM-YYYY
     ============================================================ */

  match =
    value.match(
      /^(\d{1,2})-(\d{1,2})-(\d{4})$/
    );


  if (
    match
  ) {

    const day =
      Number(
        match[1]
      );

    const month =
      Number(
        match[2]
      );

    const year =
      Number(
        match[3]
      );


    const date =
      new Date(
        year,
        month - 1,
        day
      );


    if (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    ) {

      return date;
    }
  }


  /* ============================================================
     DD/MM/YYYY
     ============================================================ */

  match =
    value.match(
      /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/
    );


  if (
    match
  ) {

    const day =
      Number(
        match[1]
      );

    const month =
      Number(
        match[2]
      );

    const year =
      Number(
        match[3]
      );


    const date =
      new Date(
        year,
        month - 1,
        day
      );


    if (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    ) {

      return date;
    }
  }


  /* ============================================================
     YYYY-MM-DD
     ============================================================ */

  match =
    value.match(
      /^(\d{4})-(\d{1,2})-(\d{1,2})$/
    );


  if (
    match
  ) {

    const year =
      Number(
        match[1]
      );

    const month =
      Number(
        match[2]
      );

    const day =
      Number(
        match[3]
      );


    const date =
      new Date(
        year,
        month - 1,
        day
      );


    if (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    ) {

      return date;
    }
  }


  /*
   * Final fallback
   */
  const fallback =
    new Date(
      value
    );


  if (
    !Number.isNaN(
      fallback.getTime()
    )
  ) {

    return fallback;
  }


  return null;
}


/* ============================================================
   RELATIVE DATE

   Today
   Yesterday
   2 days ago
   1 week ago
   2 weeks ago
   1 month ago
   8 months ago
   1 year ago
   ============================================================ */

function formatRelativeDate(
  dateString
) {

  const reviewDate =
    parseReviewDate(
      dateString
    );


  if (
    !reviewDate
  ) {

    return String(
      dateString || ""
    );
  }


  const now =
    new Date();


  const today =
    new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );


  const reviewDay =
    new Date(
      reviewDate.getFullYear(),
      reviewDate.getMonth(),
      reviewDate.getDate()
    );


  const millisecondsPerDay =
    1000 *
    60 *
    60 *
    24;


  const days =
    Math.round(
      (
        today.getTime() -
        reviewDay.getTime()
      ) /
      millisecondsPerDay
    );


  /*
   * Future date
   */
  if (
    days < 0
  ) {

    return String(
      dateString
    );
  }


  if (
    days === 0
  ) {

    return "Today";
  }


  if (
    days === 1
  ) {

    return "Yesterday";
  }


  if (
    days < 7
  ) {

    return `${days} days ago`;
  }


  if (
    days < 30
  ) {

    const weeks =
      Math.floor(
        days / 7
      );


    return `${weeks} week${
      weeks === 1
        ? ""
        : "s"
    } ago`;
  }


  if (
    days < 365
  ) {

    const months =
      Math.floor(
        days / 30
      );


    return `${months} month${
      months === 1
        ? ""
        : "s"
    } ago`;
  }


  const years =
    Math.floor(
      days / 365
    );


  return `${years} year${
    years === 1
      ? ""
      : "s"
  } ago`;
}


/* ============================================================
   DATE FOR SORTING
   ============================================================ */

function getReviewTimestamp(
  value
) {

  const date =
    parseReviewDate(
      value
    );


  if (
    !date
  ) {

    return 0;
  }


  return date.getTime();
}


/* ============================================================
   COLLECTION CARD STARS
   ============================================================ */

async function renderCollectionStars() {

  const nodes =
    document.querySelectorAll(
      "[data-cr-collection-stars]:not([data-cr-done])"
    );


  if (
    !nodes.length
  ) {

    return;
  }


  try {

    const data =
      await loadReviews();


    nodes.forEach(
      el => {

        const handle =
          getElementHandle(
            el,
            "data-cr-collection-stars",
            false
          );


        crLog(
          "Collection product:",
          handle
        );


        const reviews =
          data[
            handle
          ] ||
          [];


        if (
          !reviews.length
        ) {

          /*
           * No matching reviews.
           */
          el.style.display =
            "none";


          el.setAttribute(
            "data-cr-done",
            "1"
          );


          return;
        }


        const {
          avg,
          total
        } =
          computeStats(
            reviews
          );


        el.style.display =
          "";


        el.innerHTML = `

          ${starsHTML(avg)}

          <span class="cr-count">
            (${total})
          </span>

          <span class="visually-hidden">
            Rated ${avg.toFixed(1)}
            out of 5 based on
            ${total}
            review${total === 1 ? "" : "s"}.
          </span>

        `;


        el.setAttribute(
          "data-cr-done",
          "1"
        );
      }
    );


  } catch (
    error
  ) {

    crError(
      "Collection render error:",
      error
    );
  }
}


/* ============================================================
   PRODUCT PAGE SUMMARY
   ============================================================ */

async function renderProductSummary() {

  const nodes =
    document.querySelectorAll(
      "[data-cr-summary]:not([data-cr-done])"
    );


  if (
    !nodes.length
  ) {

    return;
  }


  try {

    const data =
      await loadReviews();


    nodes.forEach(
      el => {

        /*
         * IMPORTANT:
         * Falls back to current Shopify URL.
         */
        const handle =
          getElementHandle(
            el,
            "data-cr-summary",
            true
          );


        crLog(
          "Product summary handle:",
          handle
        );


        const reviews =
          data[
            handle
          ] ||
          [];


        crLog(
          "Product summary reviews:",
          reviews
        );


        if (
          !reviews.length
        ) {

          el.style.display =
            "none";


          el.setAttribute(
            "data-cr-done",
            "1"
          );


          return;
        }


        const {
          avg,
          total
        } =
          computeStats(
            reviews
          );


        el.style.display =
          "";


        el.innerHTML = `

          ${starsHTML(avg)}

          <span class="cr-avg">
            ${avg.toFixed(1)}
          </span>

          <span class="cr-count">
            (${total}
            review${total === 1 ? "" : "s"})
          </span>

        `;


        function scrollToReviews() {

          const full =
            document.querySelector(
              "[data-cr-full]"
            );


          if (
            full
          ) {

            full.scrollIntoView({
              behavior:
                "smooth",

              block:
                "start"
            });
          }
        }


        el.addEventListener(
          "click",
          scrollToReviews
        );


        el.addEventListener(
          "keydown",
          event => {

            if (
              event.key === "Enter" ||
              event.key === " "
            ) {

              event.preventDefault();


              scrollToReviews();
            }
          }
        );


        el.setAttribute(
          "data-cr-done",
          "1"
        );
      }
    );


  } catch (
    error
  ) {

    crError(
      "Product summary render error:",
      error
    );
  }
}


/* ============================================================
   FULL PRODUCT REVIEW SECTION
   ============================================================ */

async function renderFullSection() {

  const nodes =
    document.querySelectorAll(
      "[data-cr-full]:not([data-cr-done])"
    );


  if (
    !nodes.length
  ) {

    return;
  }


  let data;


  try {

    data =
      await loadReviews();


  } catch (
    error
  ) {

    nodes.forEach(
      el => {

        el.innerHTML = `
          <p class="cr-empty">
            Reviews are temporarily unavailable.
          </p>
        `;
      }
    );


    crError(
      "Full section load failed:",
      error
    );


    return;
  }


  nodes.forEach(
    el => {

      /*
       * IMPORTANT:
       * Falls back to current Shopify product URL.
       */
      const handle =
        getElementHandle(
          el,
          "data-cr-full",
          true
        );


      const currentHandle =
        getCurrentProductHandle();


      crLog(
        "Review section attribute:",
        el.getAttribute(
          "data-cr-full"
        )
      );


      crLog(
        "Normalized review handle:",
        handle
      );


      crLog(
        "Current Shopify handle:",
        currentHandle
      );


      crLog(
        "Available Sheet handles:",
        Object.keys(
          data
        )
      );


      const reviews =
        data[
          handle
        ] ||
        [];


      crLog(
        `Reviews found for ${handle}:`,
        reviews.length
      );


      /* ========================================================
         NO MATCHING REVIEWS
         ======================================================== */

      if (
        !reviews.length
      ) {

        el.innerHTML = `

          <p class="cr-empty">
            No reviews yet for this product.
          </p>

        `;


        el.setAttribute(
          "data-cr-done",
          "1"
        );


        return;
      }


      const {
        counts,
        total,
        avg
      } =
        computeStats(
          reviews
        );


      /* ========================================================
         RATING BREAKDOWN
         ======================================================== */

      let barsHTML =
        "";


      for (
        let star = 5;
        star >= 1;
        star--
      ) {

        const count =
          counts[
            star
          ] ||
          0;


        const percent =
          total > 0
            ? Math.round(
                (
                  count /
                  total
                ) *
                100
              )
            : 0;


        barsHTML += `

          <div class="cr-bar-row">

            <span class="cr-bar-label">
              ${star} star
            </span>

            <div
              class="cr-bar-track"
              role="progressbar"
              aria-valuemin="0"
              aria-valuemax="${total}"
              aria-valuenow="${count}"
              aria-label="${star} star reviews: ${count}"
            >

              <div
                class="cr-bar-fill"
                data-cr-percent="${percent}"
                style="
                  width:${percent}% !important;
                  height:100% !important;
                  display:block !important;
                  background:#f5a623 !important;
                "
              ></div>

            </div>

            <span class="cr-bar-count">
              ${count}
            </span>

          </div>

        `;
      }


      /* ========================================================
         SORT NEWEST FIRST
         ======================================================== */

      const sorted =
        [...reviews].sort(
          (
            a,
            b
          ) => {

            return (
              getReviewTimestamp(
                b.date
              ) -
              getReviewTimestamp(
                a.date
              )
            );
          }
        );


      /* ========================================================
         INDIVIDUAL REVIEW HTML
         ======================================================== */

      function createReviewHTML(
        review
      ) {

        return `

          <div
            class="cr-review"
            data-cr-review-id="${escapeHTML(
              review.id
            )}"
          >

            <div class="cr-review-top">

              <div>

                ${starsHTML(
                  review.rating
                )}

                <span class="visually-hidden">
                  ${review.rating}
                  out of 5 stars
                </span>

              </div>


              ${
                review.date
                  ? `

                    <span
                      class="cr-review-date"
                      title="${escapeHTML(
                        review.date
                      )}"
                    >

                      ${escapeHTML(
                        formatRelativeDate(
                          review.date
                        )
                      )}

                    </span>

                  `
                  : ""
              }

            </div>


            <div class="cr-review-name">

              ${escapeHTML(
                review.name
              )}

            </div>


            ${
              review.text
                ? `

                  <p class="cr-review-text">

                    ${escapeHTML(
                      review.text
                    )}

                  </p>

                `
                : ""
            }

          </div>

        `;
      }


      /* ========================================================
         PAGINATION
         ======================================================== */

      const totalPages =
        Math.max(
          1,
          Math.ceil(
            sorted.length /
            REVIEWS_PER_PAGE
          )
        );


      let currentPage =
        1;


      /* ========================================================
         MAIN HTML
         ======================================================== */

      el.innerHTML = `

        <div class="cr-full-header">

          <div class="cr-full-avg">

            <span class="cr-full-avg-number">
              ${avg.toFixed(1)}
            </span>

            ${starsHTML(avg)}

            <span class="cr-full-total">

              ${total}
              review${total === 1 ? "" : "s"}

            </span>

          </div>


          <div class="cr-full-bars">

            ${barsHTML}

          </div>

        </div>


        <div
          class="cr-review-list"
          data-cr-review-list
        ></div>


        <div
          class="cr-pagination"
          data-cr-pagination
        ></div>

      `;


      /* ========================================================
         FORCE BAR WIDTHS
         ======================================================== */

      el.querySelectorAll(
        ".cr-bar-fill"
      ).forEach(
        fill => {

          const rawPercent =
            Number(
              fill.getAttribute(
                "data-cr-percent"
              )
            );


          const percent =
            Number.isFinite(
              rawPercent
            )
              ? Math.max(
                  0,
                  Math.min(
                    100,
                    rawPercent
                  )
                )
              : 0;


          fill.style.setProperty(
            "width",
            `${percent}%`,
            "important"
          );


          fill.style.setProperty(
            "height",
            "100%",
            "important"
          );


          fill.style.setProperty(
            "display",
            "block",
            "important"
          );


          fill.style.setProperty(
            "background",
            "#f5a623",
            "important"
          );
        }
      );


      /* ========================================================
         RENDER PAGE
         ======================================================== */

      function renderReviewPage(
        page
      ) {

        const reviewList =
          el.querySelector(
            "[data-cr-review-list]"
          );


        const pagination =
          el.querySelector(
            "[data-cr-pagination]"
          );


        if (
          !reviewList ||
          !pagination
        ) {

          return;
        }


        currentPage =
          Math.max(
            1,
            Math.min(
              page,
              totalPages
            )
          );


        const start =
          (
            currentPage -
            1
          ) *
          REVIEWS_PER_PAGE;


        const pageReviews =
          sorted.slice(
            start,
            start +
            REVIEWS_PER_PAGE
          );


        reviewList.innerHTML =
          pageReviews
            .map(
              createReviewHTML
            )
            .join("");


        /* ======================================================
           ONE PAGE ONLY
           ====================================================== */

        if (
          totalPages <= 1
        ) {

          pagination.innerHTML =
            "";


          pagination.style.display =
            "none";


          return;
        }


        pagination.style.display =
          "flex";


        /* ======================================================
           PAGINATION BUTTONS
           ====================================================== */

        let paginationHTML =
          "";


        for (
          let pageNumber = 1;
          pageNumber <= totalPages;
          pageNumber++
        ) {

          paginationHTML += `

            <button
              type="button"

              class="cr-page-button${
                pageNumber === currentPage
                  ? " cr-page-button--active"
                  : ""
              }"

              data-cr-page="${pageNumber}"

              aria-label="Go to review page ${pageNumber}"

              ${
                pageNumber === currentPage
                  ? 'aria-current="page"'
                  : ""
              }
            >

              ${pageNumber}

            </button>

          `;
        }


        if (
          currentPage <
          totalPages
        ) {

          paginationHTML += `

            <button
              type="button"
              class="cr-page-next"
              data-cr-next
              aria-label="Next review page"
            >
              &#8250;
            </button>

          `;
        }


        pagination.innerHTML =
          paginationHTML;


        /* ======================================================
           PAGE BUTTON CLICK
           ====================================================== */

        pagination
          .querySelectorAll(
            "[data-cr-page]"
          )
          .forEach(
            button => {

              button.addEventListener(
                "click",
                () => {

                  const nextPage =
                    Number(
                      button.getAttribute(
                        "data-cr-page"
                      )
                    );


                  if (
                    !Number.isFinite(
                      nextPage
                    )
                  ) {

                    return;
                  }


                  renderReviewPage(
                    nextPage
                  );


                  reviewList.scrollIntoView({
                    behavior:
                      "smooth",

                    block:
                      "start"
                  });
                }
              );
            }
          );


        /* ======================================================
           NEXT BUTTON
           ====================================================== */

        const nextButton =
          pagination.querySelector(
            "[data-cr-next]"
          );


        if (
          nextButton
        ) {

          nextButton.addEventListener(
            "click",
            () => {

              if (
                currentPage <
                totalPages
              ) {

                renderReviewPage(
                  currentPage +
                  1
                );


                reviewList.scrollIntoView({
                  behavior:
                    "smooth",

                  block:
                    "start"
                });
              }
            }
          );
        }
      }


      renderReviewPage(
        1
      );


      el.setAttribute(
        "data-cr-done",
        "1"
      );
    }
  );
}


/* ============================================================
   RENDER EVERYTHING
   ============================================================ */

function renderAll() {

  injectCustomReviewStyles();


  renderCollectionStars();


  renderProductSummary();


  renderFullSection();
}


/* ============================================================
   INITIAL LOAD
   ============================================================ */

if (
  document.readyState ===
  "loading"
) {

  document.addEventListener(
    "DOMContentLoaded",
    renderAll
  );


} else {

  renderAll();
}


/* ============================================================
   AJAX / DYNAMIC SHOPIFY SECTIONS
   ============================================================ */

let crObserverTimer =
  null;


const crObserver =
  new MutationObserver(
    () => {

      clearTimeout(
        crObserverTimer
      );


      crObserverTimer =
        setTimeout(
          renderAll,
          150
        );
    }
  );


crObserver.observe(
  document.documentElement,
  {
    childList:
      true,

    subtree:
      true
  }
);


/* ============================================================
   SHOPIFY THEME EDITOR SUPPORT
   ============================================================ */

document.addEventListener(
  "shopify:section:load",
  () => {

    setTimeout(
      renderAll,
      100
    );
  }
);


/* ============================================================
   DEBUG TEST

   Open browser Console and run:

   crReviewDebug()

   It will show:
   - current Shopify handle
   - Google Sheet handles
   - reviews for current product
   ============================================================ */

window.crReviewDebug =
  async function () {

    try {

      const data =
        await loadReviews();


      const currentHandle =
        getCurrentProductHandle();


      console.log(
        "=============================="
      );

      console.log(
        "CUSTOM REVIEW DEBUG"
      );

      console.log(
        "Current Shopify handle:",
        currentHandle
      );

      console.log(
        "Google Sheet handles:",
        Object.keys(
          data
        )
      );

      console.log(
        "Reviews for current product:",
        data[
          currentHandle
        ] ||
        []
      );

      console.log(
        "Full review elements:",
        document.querySelectorAll(
          "[data-cr-full]"
        ).length
      );

      console.log(
        "Summary elements:",
        document.querySelectorAll(
          "[data-cr-summary]"
        ).length
      );

      console.log(
        "Collection rating elements:",
        document.querySelectorAll(
          "[data-cr-collection-stars]"
        ).length
      );

      console.log(
        "=============================="
      );


    } catch (
      error
    ) {

      console.error(
        "CUSTOM REVIEW DEBUG ERROR:",
        error
      );
    }
  };